import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const MOBILE_APP_CONFIGURATION_URL = `${API_HOST}/api/mobileAppConfiguration`;
const COPYWRITING_URL = `/copywriting`;

function* createMobileAppConfiguration() {
  yield takeEvery(actions.CREATE_MOBILE_APP_CONFIGURATION, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], MOBILE_APP_CONFIGURATION_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MOBILE_APP_CONFIGURATION_ENDED });
    }
  });
}

function* searchMobileAppConfigurations() {
  yield takeEvery(actions.SEARCH_MOBILE_APP_CONFIGURATIONS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${MOBILE_APP_CONFIGURATION_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MOBILE_APP_CONFIGURATIONS_ENDED });
    }
  });
}

function* updateMobileAppConfiguration() {
  yield takeEvery(actions.UPDATE_MOBILE_APP_CONFIGURATION, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], MOBILE_APP_CONFIGURATION_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MOBILE_APP_CONFIGURATION_ENDED });
    }
  });
}

function* createMobileAppCopywriting() {
  yield takeEvery(actions.CREATE_MOBILE_APP_COPYWRITING, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], MOBILE_APP_CONFIGURATION_URL + COPYWRITING_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MOBILE_APP_COPYWRITING_ENDED });
    }
  });
}

function* searchMobileAppCopywritings() {
  yield takeEvery(actions.SEARCH_MOBILE_APP_COPYWRITINGS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${MOBILE_APP_CONFIGURATION_URL}${COPYWRITING_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MOBILE_APP_COPYWRITINGS_ENDED });
    }
  });
}

function* updateMobileAppCopywriting() {
  yield takeEvery(actions.UPDATE_MOBILE_APP_COPYWRITING, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], MOBILE_APP_CONFIGURATION_URL + COPYWRITING_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MOBILE_APP_COPYWRITING_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createMobileAppConfiguration),
    fork(searchMobileAppConfigurations),
    fork(updateMobileAppConfiguration),
    fork(createMobileAppCopywriting),
    fork(searchMobileAppCopywritings),
    fork(updateMobileAppCopywriting),
  ]);
}
